import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  }
});

// // Auth helper functions
// export const authHelpers = {
//   // Sign up new user
//   signUp: async (email, password, userData = {}) => {
//     try {
//       const { data, error } = await supabase.auth.signUp({
//         email,
//         password,
//         options: {
//           data: userData
//         }
//       });

//       if (error) throw error;
//       return { data, error: null };
//     } catch (error) {
//       return { data: null, error };
//     }
//   },

//   // Sign in user
//   signIn: async (email, password) => {
//     try {
//       const { data, error } = await supabase.auth.signInWithPassword({
//         email,
//         password
//       });

//       if (error) throw error;
//       return { data, error: null };
//     } catch (error) {
//       return { data: null, error };
//     }
//   },

//   // Sign out user
//   signOut: async () => {
//     try {
//       const { error } = await supabase.auth.signOut();
//       if (error) throw error;
//       return { error: null };
//     } catch (error) {
//       return { error };
//     }
//   },

//   // Get current user
//   getCurrentUser: async () => {
//     try {
//       const { data: { user }, error } = await supabase.auth.getUser();
//       if (error) throw error;
//       return { user, error: null };
//     } catch (error) {
//       return { user: null, error };
//     }
//   },

//   // Get current session
//   getCurrentSession: async () => {
//     try {
//       const { data: { session }, error } = await supabase.auth.getSession();
//       if (error) throw error;
//       return { session, error: null };
//     } catch (error) {
//       return { session: null, error };
//     }
//   },

//   // Reset password
//   resetPassword: async (email) => {
//     try {
//       const { data, error } = await supabase.auth.resetPasswordForEmail(email, {
//         redirectTo: `${window.location.origin}/reset-password`
//       });

//       if (error) throw error;
//       return { data, error: null };
//     } catch (error) {
//       return { data: null, error };
//     }
//   },

//   // Update password
//   updatePassword: async (newPassword) => {
//     try {
//       const { data, error } = await supabase.auth.updateUser({
//         password: newPassword
//       });

//       if (error) throw error;
//       return { data, error: null };
//     } catch (error) {
//       return { data: null, error };
//     }
//   }
// };

export default supabase;